import axios from 'axios';
import { API } from 'configs/api';

export const contactUsService = {
  postContact: (body) => axios.post(API.contactUs, body),
};
